import { useEffect } from 'react'
import { intercomStore } from 'store/intercomStore'

/**
 * While the calling component is mounted, request that the Intercom launcher
 * be hidden. Used by surfaces that must exclude the support agent but are not
 * their own route (e.g. the pre-session quiz dialog).
 */
export function useSuppressIntercom() {
  useEffect(() => {
    intercomStore.addSuppressor()
    return () => intercomStore.removeSuppressor()
  }, [])
}
